import { serverMediatedPage } from '../shared/reading_request';
import { startWithPhraseIdeas } from './chat/phrase_ideas_dialog';
import ChatTopicService from './chat/chat_topic_service';
import GuidedCourseConfigService from './chat/guided_course_config_service';
import consumer from "../channels/consumer"


document.addEventListener('turbolinks:load', function() {
  // A Turbolinks visit keeps the document, and the handlers bound on it by
  // earlier visits still hold that visit's (now detached) form. Drop them so
  // only this page's handlers run (LAN-1398).
  $(document).off('.chatForm');
  const chatForm = document.getElementById('new-chat-form');

  if (chatForm) {
    const chatTopic = document.getElementById('js-chat-topic');
    const chatTopicCategory = document.getElementById('js-chat-topic-category');
    const chatSubtopicCategory = document.getElementById('js-chat-subtopic-category');
    const continueConversationBtn = document.querySelector('.js-continue-conversation-btn');
    const chatPromptTitle = document.getElementById('js-chat-custom-prompt-title');
    const chatCustomPrompt = document.getElementById('js-chat-custom-prompt');
    // LAN-718: "Share my prompt with Langua" checkbox state for the auto-save.
    const chatCustomPromptShareConsent = document.getElementById('js-chat-custom-prompt-share-consent');

    // Initialize GuidedCourseConfigService for help text display
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content');
    const guidedCourseConfigService = new GuidedCourseConfigService(csrfToken);

    const urlParams = new URLSearchParams(window.location.search);
    let topicFromParams = urlParams.get('topic_category')
    if (topicFromParams) {
      const topicButton = document.querySelector(`.js-main-chat-option-btn[data-topic-category="${topicFromParams}"]`);      if (topicButton) {
        setTimeout(() => {
          topicButton.click();
        }, 200);
      }
    }

    const chatModeButtons = document.querySelectorAll('.js-chat-mode-radio-label');
    const chatVoiceOptionsEl = document.querySelectorAll('.chat-voice-options-container');
    const chatVoiceSelect = document.getElementById('chat_form_voice');
    const chatModeSelect = document.querySelector('.js-chat-mode-select');

    // Get chat mode from select dropdown or radio buttons
    let chatMode = '';
    if (chatModeSelect && chatModeSelect.options && chatModeSelect.selectedIndex >= 0) {
      // Get from select dropdown (new modal)
      chatMode = chatModeSelect.options[chatModeSelect.selectedIndex].text;
    } else {
      // Fall back to radio buttons (if they exist)
      const activeModeElement = document.querySelector('.js-chat-mode-radio-label.active');
      chatMode = activeModeElement ? activeModeElement.innerText : '';
    }

    // Also add null check for chatVoiceSelect
    let chatVoice = chatVoiceSelect && chatVoiceSelect.options && chatVoiceSelect.selectedIndex >= 0
      ? chatVoiceSelect.options[chatVoiceSelect.selectedIndex].label
      : '';

    const chatElementContainer = document.querySelector('.chat-content-w');
    const chatElement = document.querySelector('.chat-content');

    const chatTopicService = new ChatTopicService(chatElementContainer, chatElement);

    $('body').on('click', '.js-chat-options-btn', function (e) {
      $('#chatOptionsModal').modal('show');
    });

    // Store original display text for restoration on hover out
    let originalDisplayText = '';
    const displayContainer = document.querySelector('.js-display-chat-options');
    if (displayContainer) {
      const displaySpan = displayContainer.querySelector('span');
      if (displaySpan) {
        originalDisplayText = displaySpan.textContent;
      }
    }

    // Guided course version toggle state
    let selectedGuidedVersion = 'v2';
    const optionTitleRow = document.querySelector('.chat-option-title-row');

    function buildSubViewBackButtonHtml() {
      return $(`
        <div class="col-12 js-subview-back-row mb-2 d-none d-sm-block">
          <button type="button" class="btn btn-link js-chat-form-back-button js-subview-back-button px-0">
            <i class="fa fa-chevron-left mr-1" aria-hidden="true"></i>
            <span>Back</span>
          </button>
        </div>
      `);
    }

    function addSubViewBackButton(container) {
      container.find('.js-subview-back-row').remove();
      if (window.innerWidth > 767) {
        container.prepend(buildSubViewBackButtonHtml());
      }
    }

    function setCategoryNavigationState(isSubView) {
      if (optionTitleRow) {
        optionTitleRow.classList.toggle('d-none', isSubView);
      }

      const subOptionsContainer = document.querySelector('.js-sub-options-container');
      if (subOptionsContainer) {
        subOptionsContainer.classList.toggle('is-subview-active', isSubView);
      }

      const mobileBackRow = document.querySelector('.js-mobile-subview-back-row');
      if (mobileBackRow) {
        mobileBackRow.classList.toggle('d-none', !isSubView);
      }

      const introContainer = document.querySelector('.js-chat-intro-container');
      if (introContainer) {
        introContainer.classList.toggle('is-subview-active', isSubView);
      }

      document.dispatchEvent(new CustomEvent('speak:browse-subview-change', {
        detail: { isSubView, isTopLevel: !isSubView }
      }));
    }

    function buildVersionToggleHtml() {
      const v2Active = selectedGuidedVersion === 'v2';
      const v1Active = selectedGuidedVersion === 'v1';
      return $(`
        <div class="col-12 mb-3 js-version-toggle-container">
          <div class="d-flex justify-content-center">
            <button type="button"
              class="btn btn-secondary-cta-outline mb-0 js-version-toggle-btn ${v2Active ? 'active' : ''}"
              data-version="v2">
              New course
            </button>
            <button type="button"
              class="btn btn-secondary-cta-outline mb-0 js-version-toggle-btn ${v1Active ? 'active' : ''}"
              data-version="v1">
              Legacy course
            </button>
          </div>
        </div>
      `);
    }

    // Event listener for main category buttons (e.g., 'Roleplay')
    $(document).on('click.chatForm', '.js-main-chat-option-btn', function(event) {
      event.preventDefault();

      if (continueConversationBtn) {
        continueConversationBtn.classList.add('d-none');
      }

      const topicCategory = $(this).data('topic-category');
      const subOptionsContainer = $('.js-sub-options-container');
      const categories = $(this).data('topics');

      chatTopicService.showSubCategories(topicCategory, categories, subOptionsContainer);
      setCategoryNavigationState(true);

      // Show version toggle inside subcategories for guided courses
      if (topicCategory === 'guided' && $(this).data('show-version-toggle')) {
        subOptionsContainer.prepend(buildVersionToggleHtml());

        // Update hidden field to match current selection
        $('#js-chat-guided-version').val(selectedGuidedVersion);
      }

      addSubViewBackButton(subOptionsContainer);

      // Fetch and display help texts for guided/grammar/vocab courses
      const isGuidedCourse = topicCategory === 'guided' || topicCategory === 'grammar' || topicCategory === 'vocab' || topicCategory?.startsWith('grammar');
      if (isGuidedCourse) {
        // Get current voice settings from the form
        const voiceSelect = document.getElementById('chat_form_voice');
        const modeSelect = document.querySelector('.js-chat-mode-select');
        const currentSettings = {
          voice: voiceSelect?.value || '',
          mode: modeSelect?.value || ''
        };

        guidedCourseConfigService.fetchConfig(topicCategory, currentSettings).then(() => {
          guidedCourseConfigService.applyToUI();
        }).catch(error => {
          console.warn('Could not fetch guided course config:', error);
        });
      } else {
        // Reset guided course config and restore original display text
        guidedCourseConfigService.reset();
        guidedCourseConfigService.restoreDisplayText(displayContainer, originalDisplayText);
      }
    });

    // Event listener for version toggle buttons - re-render subcategories with correct topics
    $(document).on('click.chatForm', '.js-version-toggle-btn', function(event) {
      event.preventDefault();
      event.stopPropagation();

      const version = $(this).data('version');
      if (version === selectedGuidedVersion) return;

      selectedGuidedVersion = version;

      // Update button states
      $('.js-version-toggle-btn').removeClass('active');
      $(this).addClass('active');

      // Update hidden field
      $('#js-chat-guided-version').val(version);

      // Re-render subcategories with the correct topic set
      const guidedBtn = $('.js-main-chat-option-btn[data-topic-category="guided"]');
      const topics = version === 'v1' ? guidedBtn.data('topics-v1') : guidedBtn.data('topics');
      const subOptionsContainer = $('.js-sub-options-container');

      // Remove existing toggle before re-render (showSubCategories empties the container)
      chatTopicService.showSubCategories('guided', topics, subOptionsContainer);

      // Re-add the toggle at the top
      subOptionsContainer.prepend(buildVersionToggleHtml());
      addSubViewBackButton(subOptionsContainer);
    });

    // Returning to the top level (ChatTopicService#goBack dispatches this when
    // its navigation stack empties): reset guided course state + subview classes.
    $(document).on('chat:nav-top.chatForm', function() {
      guidedCourseConfigService.reset();
      guidedCourseConfigService.restoreDisplayText(displayContainer, originalDisplayText);
      setCategoryNavigationState(false);
    });

    // Event listener for subcategory buttons within a main category
    $(document).on('click.chatForm', '.js-sub-category-btn', function(event) {
      event.preventDefault();

      const topicCategory = $(this).data('topic-category');
      const topicsData = $(this).data('topics');
      const subtopicCategory = $(this).data('subtopic-category');
      const vocabSubtopic = (topicCategory === 'vocab' && subtopicCategory === 'practice_my_vocab_blend_into_chat') ||
          (topicCategory === 'vocab' && subtopicCategory === 'practice_my_vocab_word_by_word');
      const chatAboutAnythingSubtopic = (topicCategory === 'chat_about_anything' && subtopicCategory === 'my_life');

      if (topicCategory === 'my_interests' || subtopicCategory === 'my_interests') {
        const subOptionsContainer = $('.js-sub-options-container');

        if (topicsData === null || subtopicCategory === 'generated_interest') {
          if (subtopicCategory === 'generate_your_interest') {
            chatTopicService.addCategoryContent('generate_your_interest', subOptionsContainer)
          } else if (subtopicCategory === 'generated_interest') {
            // Custom interest: rows carry the interest text (the node key is
            // fixed at 'generated_interest'). With persisted pool topics,
            // render them like a predefined interest — topic buttons plus a
            // "generate more" button (the server omits that row once the
            // pool is full). Without topics, keep the generate-only view.
            const interestName = (topicsData && topicsData[0] && (topicsData[0].interest || topicsData[0].key)) || '';
            const hasPoolTopics = Array.isArray(topicsData) &&
              topicsData.some(t => t.key !== 'generate_random_interests_title' && t.key !== interestName);

            if (hasPoolTopics) {
              chatTopicService.showSubCategories(interestName, topicsData, subOptionsContainer);
            } else {
              chatTopicService.addCategoryContent('generated_interest', subOptionsContainer, interestName);
            }
          } else {
            chatTopicService.addCategoryContent('my_interests', subOptionsContainer)
          }
        } else {
          chatTopicService.showSubCategories(subtopicCategory, topicsData, subOptionsContainer);
        }
        addSubViewBackButton(subOptionsContainer);
      } else if(topicCategory === 'custom_conversation' && subtopicCategory === 'create_new') {
        const subOptionsContainer = $('.js-sub-options-container');
        const userPrompts = $('.chat-content').data('userPrompts');
        chatTopicService.addCategoryContent('custom_conversation', subOptionsContainer, null, userPrompts)
        addSubViewBackButton(subOptionsContainer);
      } else if(topicCategory === 'custom_conversation' && subtopicCategory === 'my_prompts') {
        const subOptionsContainer = $('.js-sub-options-container');
        const userPrompts = $('.chat-content').data('userPrompts');
        chatTopicService.addCategoryContent('my_prompts', subOptionsContainer, null, userPrompts)
        addSubViewBackButton(subOptionsContainer);
      } else if (topicCategory === 'roleplay' || vocabSubtopic || chatAboutAnythingSubtopic) {
        chatTopicService.showSubOptions(topicCategory, subtopicCategory, topicsData);
        addSubViewBackButton($('.js-sub-options-container'));
      } else if (topicCategory === 'grammar') {
        if (subtopicCategory === 'custom') {
          chatTopicService.showSubOptions(topicCategory, subtopicCategory, topicsData);
          addSubViewBackButton($('.js-sub-options-container'));
        } else {
          const subOptionsContainer = $('.js-sub-options-container');
          // Pass the clicked topic's localized label so the grammar explanation
          // button/title can display it (the request still uses the English key).
          chatTopicService.showSubCategories(subtopicCategory, topicsData, subOptionsContainer, $(this).text().trim());
          addSubViewBackButton(subOptionsContainer);
        }
      } else if (topicCategory === 'grammar_recommended' || topicCategory.startsWith('grammar_by_level_') || topicCategory === 'grammar_all_levels') {
        const subOptionsContainer = $('.js-sub-options-container');
        chatTopicService.showSubCategories(subtopicCategory, topicsData, subOptionsContainer, $(this).text().trim());
        addSubViewBackButton(subOptionsContainer);
      } else {
        chatTopicCategory.value = topicCategory;
        chatTopic.value = subtopicCategory;
        startWithPhraseIdeas({ category: topicCategory, topicKey: subtopicCategory, title: $(this).text().trim() }, () => chatForm.submit());
      }
    });

    // Event listener for final topic selection
    $(document).on('click.chatForm', '.js-sub-chat-option-btn', function(event) {
      event.preventDefault();

      const topic = $(this).data('topic');
      const topicCategory = $(this).data('topic-category');
      const subtopicCategory = $(this).data('subtopic-category');
      if (topic === 'manual_selection') {
        chatTopicService.showVocabSelection(topic, topicCategory, subtopicCategory);
        return;
      }
      chatTopicCategory.value = topicCategory;
      chatSubtopicCategory.value = subtopicCategory;
      chatTopic.value = topic;
      startWithPhraseIdeas({ category: topicCategory, subtopic: subtopicCategory, topicKey: topic, title: $(this).text().trim() }, () => chatForm.submit());
    });

    $(document).on('click.chatForm', '.js-generate-custom-conversation-btn', function(event) {
      event.preventDefault();

      const topic = $(this).data('topic');
      const topicCategory = $(this).data('topic-category');
      const subtopicCategory = $(this).data('subtopic-category');
      const promptTitle = $(this).data('prompt-title');
      const customPrompt = $(this).data('custom-prompt');

      chatTopicCategory.value = topicCategory;
      chatSubtopicCategory.value = subtopicCategory;
      chatTopic.value = topic;
      chatPromptTitle.value = promptTitle;
      chatCustomPrompt.value = customPrompt;
      if (chatCustomPromptShareConsent) {
        const consent = $(this).attr('data-share-consent');
        chatCustomPromptShareConsent.value = consent === undefined ? '' : (String(consent) === '1' ? '1' : '0');
      }
      chatForm.submit();
    });

    // Event listener for grammar explanation button
    $(document).on('click.chatForm', '.js-grammar-explanation-btn', function(event) {
      event.preventDefault();
      
      const grammarTopic = $(this).data('grammarTopic');
      // Localized label for the title only; grammarTopic (English) is used for the request.
      const grammarTopicLabel = $(this).data('grammarTopicLabel') || grammarTopic;

      // Create and show the modal
      if ($('#grammarExplanationModal').length === 0) {
        const modalHtml = `
          <div class="modal fade" id="grammarExplanationModal" tabindex="-1" role="dialog" aria-labelledby="grammarExplanationModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-lg" role="document">
              <div class="modal-content">
                <div class="modal-header" style="padding-left: 2rem; padding-top: 2rem">
                  <h5 class="modal-title" id="grammarExplanationModalLabel">${I18n.t('javascript.chat_form.grammar_explainer_title', { topic: grammarTopicLabel })}</h5>
                  <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body" style="padding: 2rem">
                  <div id="grammarExplanationContent">
                    <div class="text-center py-3">
                      <p class="mt-3">${I18n.t('javascript.chat_form.generating_explanation')}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        `;
        $('body').append(modalHtml);
      } else {
        $('.modal-title').text(I18n.t('javascript.chat_form.grammar_explainer_title', { topic: grammarTopicLabel }));
        $('#grammarExplanationContent').html(`
          <div class="text-center py-3">
            <p class="mt-3">${I18n.t('javascript.chat_form.generating_explanation')}</p>
          </div>
        `);
      }
      
      $('#grammarExplanationModal').modal('show');
      
      // Subscribe to WebSocket channel for receiving the explanation
      const subscription = consumer.subscriptions.create(
        { channel: "GrammarExplanationChannel", grammar_topic: grammarTopic },
        {
          received: (data) => {
            if (serverMediatedPage() && data.grammar_topic !== grammarTopic) return;
            if (data.completed) {
              if (data.error) {
                console.error('Error generating grammar explanation:', data.error);
                $('#grammarExplanationContent').html(`
                  <div class="alert alert-danger">
                    <h6><i class="fa fa-exclamation-triangle"></i> ${I18n.t('javascript.chat_form.unable_load_explanation')}</h6>
                    <p>${I18n.t('javascript.chat_form.try_again_later')}</p>
                  </div>
                `);
              } else {
                let explanation = data.explanation;
                if (serverMediatedPage()) {
                  const escaped = document.createElement('span');
                  escaped.textContent = explanation;
                  explanation = escaped.innerHTML;
                }
                $('#grammarExplanationContent').html(`
                  <p style="line-height: 1.6; font-size: 1rem">
                    ${explanation.replace(/\*\*(.+?)\*\*/g, '<b>$1</b>')
                                      .replace(/\*(.+?)\*/g, '<b>$1</b>')
                                      .replace(/\n/g, '<br>')}
                  </p>
                `);
              }
              // Unsubscribe after receiving the result
              subscription.unsubscribe();
            }
          },
        }
      );
      
      // Start the background job
      $.ajax({
        url: '/langua/grammar_explanations',
        method: 'POST',
        data: {
          grammar_topic: grammarTopic
        },
        success: function(data) {
          console.log('Grammar explanation generation started:', data.message);
        },
        error: function(xhr, status, error) {
          console.error('Error starting grammar explanation generation:', error);
          $('#grammarExplanationContent').html(`
            <div class="alert alert-danger">
              <h6><i class="fa fa-exclamation-triangle"></i> ${I18n.t('javascript.chat_form.unable_load_explanation')}</h6>
              <p>${I18n.t('javascript.chat_form.try_again_later')}</p>
            </div>
          `);
          subscription.unsubscribe();
        }
      });
    });

    $(document).on('click.chatForm', '.js-generate-topic-titles-btn', function(event) {
      event.preventDefault();
      
      const parentDiv = $(this).closest('.col-12');
      const button = parentDiv.find('button');
      const topicCategory = button.data('topic-category') || this.dataset.topicCategory;

      $(this).text(I18n.t('javascript.chat_form.loading')).prop('disabled', true);
      
      consumer.subscriptions.create({ channel: "ChatInterestTitlesChannel", interest: topicCategory }, {
        received: (data) => {
          if (data.completed) {
            if (data.error) {
              console.error('Error generating titles:', data.error);
            } else {
              const container = parentDiv.parent();
              const generateButtonDiv = $('.js-generate-topic-titles-btn').closest('.col-12');
              generateButtonDiv.remove();
              
              data.topics.forEach(topic => {
                const divHtml = $(`<div class="col-12 col-md-6 col-lg-4 chat-topic-button-col"></div>`);
                const buttonHtml = $(`<button type="button"
                  class="btn btn-secondary-cta-outline chat-topic-button py-3 chat-option-button w-100 mb-2 js-sub-category-btn"
                  data-topic-category="${topicCategory}"
                  data-subtopic-category="${(topic.key || '').replace(/"/g, '&quot;')}"
                  data-topics=''>${topic.label}</button>`);
                
                divHtml.append(buttonHtml);
                container.append(divHtml);
                $('.js-sub-options-container').css({'overflow-y': 'auto', 'max-height': '70vh'});
              });
            }
          }
        }
      });

      $.ajax({
        url: '/langua/chat_interest_titles',
        method: 'POST',
        data: {
          interest: topicCategory
        },
        error: (xhr, status, error) => {
          console.error('Error starting title generation:', error);
        }
      });
    });

    chatModeButtons.forEach(function(button) {
      button.addEventListener('click', function(e) {

        // Remove active class from all buttons
        chatModeButtons.forEach(function(btn) { btn.classList.remove('active'); });

        // Add active class to the clicked button
        this.classList.add('active');

        // Ensure the associated radio button is checked
        var inputElement = this.previousElementSibling;
        inputElement.checked = true;

        // Get input value from input above the label
        var modeValue = inputElement.value;

        switch(modeValue) {
          case 'text_only':
            chatVoiceOptionsEl.forEach(el => el.classList.add('d-none'));
            break;
          case 'audio_only':
            chatVoiceOptionsEl.forEach(el => el.classList.remove('d-none'));
            break;
          case 'text_audio':
            chatVoiceOptionsEl.forEach(el => el.classList.remove('d-none'));
            break;
          case 'call_mode':
            chatVoiceOptionsEl.forEach(el => el.classList.remove('d-none'));
            break;
        }

        // Set chat mode to be button text
        chatMode = e.target.innerText;
        updateChatOptionsDisplay();
      });
    });

    if (chatVoiceSelect) {
      chatVoiceSelect.addEventListener('change', function(e) {
        // set chat voice to be the label of the selected option
        chatVoice = e.target.options[e.target.selectedIndex].label;
        updateChatOptionsDisplay();
      });
    }

    // Also listen to the modal's mode select dropdown
    if (chatModeSelect) {
      chatModeSelect.addEventListener('change', function(e) {
        const selectedMode = e.target.value;
        
        // Update chatMode variable to match the display text format
        switch(selectedMode) {
          case 'text_only':
            chatMode = I18n.t('javascript.chat.modes.text_only');
            chatVoiceOptionsEl.forEach(el => el.classList.add('d-none'));
            break;
          case 'audio_only':
            chatMode = I18n.t('javascript.chat.modes.audio_only');
            chatVoiceOptionsEl.forEach(el => el.classList.remove('d-none'));
            break;
          case 'text_audio':
            chatMode = I18n.t('javascript.chat.modes.text_audio');
            chatVoiceOptionsEl.forEach(el => el.classList.remove('d-none'));
            break;
          case 'call_mode':
            chatMode = I18n.t('javascript.chat.modes.call_mode');
            chatVoiceOptionsEl.forEach(el => el.classList.remove('d-none'));
            break;
          default:
            chatMode = I18n.t('javascript.chat.modes.text_audio');
            chatVoiceOptionsEl.forEach(el => el.classList.remove('d-none'));
            break;
        }
        
        updateChatOptionsDisplay();
      });
    }

    function updateChatOptionsDisplay() {
      // Only update if we have a valid chatMode
      if (!chatMode || chatMode === '') {
        return; // Don't overwrite the server-rendered text if we don't have a mode
      }

      // Update only the span text, preserving help texts container
      const displayContainer = document.querySelector('.js-display-chat-options');
      if (!displayContainer) return;

      let displaySpan = displayContainer.querySelector('span');
      if (!displaySpan) {
        // Create span if it doesn't exist
        displaySpan = document.createElement('span');
        displayContainer.insertBefore(displaySpan, displayContainer.firstChild);
      }

      if (chatMode === I18n.t('javascript.chat.modes.text_only')) {
        displaySpan.textContent = I18n.t('javascript.chat_form.chatting_in_mode', { mode: chatMode });
      } else if (chatVoice) {
        displaySpan.textContent = I18n.t('javascript.chat_form.chatting_with_voice_in_mode', { voice: chatVoice, mode: chatMode });
      }
    }

    // Back-button navigation is owned by ChatTopicService's explicit nav
    // stack (see chat_topic_service.js) — the old DOM-sniffing depth
    // heuristic ("backfix") lived here and was removed with it.
  }
});
